export default __webpack_public_path__ + "static/media/ladiesBag1.23723b07.jpg";